export default "__VITE_ASSET__YwiAA7Dv__"